import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export default function FrameRate({
  value,
  onChange,
}: {
  value: string;
  onChange: (frameRate: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select frame rate" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="Match Source">Match Source</SelectItem>
        <SelectItem value="24 fps">24 fps</SelectItem>
        <SelectItem value="25 fps">25 fps</SelectItem>
        <SelectItem value="30 fps">30 fps</SelectItem>
        <SelectItem value="50 fps">50 fps</SelectItem>
        <SelectItem value="60 fps">60 fps</SelectItem>
      </SelectContent>
    </Select>
  );
}
